import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	actions: {
		id: 'servicedesk.queues.agent-view.layout.queues-details.actions.actions',
		defaultMessage: 'Actions',
		description: 'Text for actions button to open an actions menu',
	},
});
